module.exports = __webpack_public_path__ + "img/icon_bed_black.359fef58.svg";